<app-skeleton [loading]="loading" height="220px">
    <app-source-detail [baseInfo]="baseInfo"
        [capacityPercentData]="capacityPercentData"
        [detail]="detail"
        [event]="item"
        [icon]="item ? iconMap[item.type] : ''"
        [loading]="updateLoading"
        [threSholdList]="threSholdList"
    >
    </app-source-detail>
</app-skeleton>
